export default () => ({
    items: {},
    count: 0,
    page: 0,
    showCheckbox: 1,
    headers: {},
    loading: false,
    paginationShow: false,
    pagination: {},
    error: '',

    init() {
        this.load();
        this.setPaginationShow();
    },

    value: {
        ['@click']() {
            if(this.modal !== undefined) {
                this.$dispatch('openmodal', this.modal);
            }
        },
    },

    outer: {
        [':class']() {
            return this.loading ? 'loading' : '';
        },
    },

    setPaginationShow() {
        if (this.count == Object.keys(this.items).length) {
            this.paginationShow = false;
        }
        else {
            this.paginationShow = true;
        }
    },

    async load(page = null, clear = true) {
        if(page !== null) {
            this.page = page;
        }
        else {
            this.page++;
        }

        this.loading = true;

        const response = await fetch(`/api/manager/${this.action}?&page=${this.page}`, {
            method: 'GET',
        });

        const result = await response.json();

        this.error = result.error;
        this.showCheckbox = result.showCheckbox;
        this.headers = result.headers;
        this.count = result.count;

        if (clear) {
            this.items = result.items;
        }
        else {
            this.items = Object.assign(this.items, result.items);
        }
        
        this.loading = false;
        this.pagination = result.pagination;

        this.setPaginationShow();

        document.dispatchEvent(new Event('listLoaded'));

    }
})
